import { render, staticRenderFns } from "./color-palette.vue?vue&type=template&id=52c8e9a0&scoped=true&"
import script from "./color-palette.vue?vue&type=script&lang=js&"
export * from "./color-palette.vue?vue&type=script&lang=js&"
import style0 from "./color-palette.vue?vue&type=style&index=0&id=52c8e9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8e9a0",
  null
  
)

export default component.exports